(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["wix-default-custom-element"] = factory();
	else
		root["wix-default-custom-element"] = factory();
})(this, function() {
return 